export default __webpack_public_path__ + "static/media/karen-and-sam-wedding.dcb5bb32.jpeg";